<template>
  <div class="preview-card" @mouseover="openTooltip" @mouseout="closeTooltip">
    <div class="preview-card__body">
      <button class="preview-card__image" @click="navigate">
        <img v-if="planURL" :src="planURL" alt @error="planImageError" />
        <p class="preview-card__noimg" v-else>{{ $t('singleFlat.noPrev') }}</p>
      </button>
      <Tooltip :visible="tooltipVisible">
        <FlatTooltip :flat="flat"></FlatTooltip>
      </Tooltip>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import Tooltip from '@/components/tooltip';
import FlatTooltip from '@/components/flat/flat-tooltip';

export default {
  name: 'flat-preview-card',
  data() {
    return {
      tooltipVisible: false,
      planError: false,
    };
  },
  props: ['flat'],
  components: { Tooltip, FlatTooltip },
  methods: {
    ...mapMutations({
      addToFavourites: 'ADD_TO_FAVOURITES',
      deleteFromFavourites: 'DELETE_FROM_FAVOURITES',
    }),
    toggleFavourites() {
      if (this.isFavourite) {
        this.deleteFromFavourites(this.flat);
      } else {
        this.addToFavourites(this.flat);
      }
    },
    openTooltip() {
      this.tooltipVisible = true;
    },
    closeTooltip() {
      this.tooltipVisible = false;
    },
    navigate() {
      this.closeTooltip();
      this.$nextTick(() => {
        this.$router.push(
          `/${this.investmentURL}/flat/${this.flat[this.flatProperties['id']]}`
        );
      });
    },
    planImageError(e) {
      this.planError = true;
    },
  },
  computed: {
    ...mapState({ flatProperties: state => state.browser.flatProperties }),
    ...mapGetters({ getPlan: 'GET_PLAN' }),
    status() {
      return this.$store.getters.GET_STATUS_CLASS(
        this.flat[this.flatProperties['status']]
      );
    },
    id() {
      return this.flat[this.flatProperties['id']].toUpperCase();
    },
    investmentURL() {
      return this.$store.state.browser.currentInvestment.url;
    },
    planURL() {
      if (this.planError == true) {
        return false;
      }
      if (!this.flat) return false;

      return this.getPlan(this.flat[this.flatProperties['realID']]);
    },
    isFavourite() {
      let favs = this.$store.getters.GET_FAVOURITES.map(
        fav => fav[this.flatProperties['id']]
      );
      return favs.includes(this.flat[this.flatProperties['id']]);
    },
  },
};
</script>

<style lang="scss">
.preview-card {
  width: 110px;
  height: 110px;
  background: #fff;
  border: 1px solid $lightGray;
  border-radius: 20px;
  position: relative;
  margin: {
    left: 10px;
    right: 10px;
  }
  transition: 200ms;

  &:hover {
    border-color: $primaryColor;
  }
  @media screen and (max-width: $sm) {
    width: 80px;
    height: 80px;
  }
}

.preview-card__body {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
}

.preview-card__noimg {
  font-size: 10px;
  text-align: center;
  @media screen and (max-width: $sm) {
    font-size: 8px;
  }
}

.preview-card__image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  background: none;
  border: none;
  box-shadow: none;
  color: #000000;
  font-size: 20px;
  cursor: pointer;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.preview-card__line {
  border: 0.5px solid rgba(#000000, 0.04);
}

.preview-card__favourite {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  background: $primaryColor;
  padding: 12px 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transform: translate(-25%, -25%);
}
</style>
